"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var accessors_1 = require("../themes/accessors");
var StyledText = styled_components_1.default('li')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style-type: none;\n  color: ", ";\n  font-size: ", "px;\n  font-family: ", ";\n  font-weight: ", ";\n"], ["\n  list-style-type: none;\n  color: ", ";\n  font-size: ", "px;\n  font-family: ", ";\n  font-weight: ", ";\n"])), accessors_1.textColor('contrast'), accessors_1.fontSize('label'), accessors_1.fontFamily('sansSerif'), function (_a) {
    var isSelected = _a.isSelected;
    return isSelected ? 700 : 400;
});
var StyledButton = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: transparent;\n  border-width: 0;\n  padding: 0;\n  cursor: pointer;\n  color: ", ";\n"], ["\n  background-color: transparent;\n  border-width: 0;\n  padding: 0;\n  cursor: pointer;\n  color: ", ";\n"])), accessors_1.textColor('contrast'));
var Breadcrumb = function (_a) {
    var label = _a.label, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, _c = _a.tag, tag = _c === void 0 ? 'li' : _c, onClick = _a.onClick, otherProps = __rest(_a, ["label", "isSelected", "tag", "onClick"]);
    return react_1.default.createElement(StyledText, __assign({ isSelected: isSelected, as: tag }, otherProps),
        react_1.default.createElement(StyledButton, { onClick: onClick }, label));
};
exports.Breadcrumb = Breadcrumb;
exports.default = exports.Breadcrumb;
var templateObject_1, templateObject_2;
